// Styles for HotelCard go here.
import { baseVariables, contextualVariable, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledHotelCard = styled.div`
  .mini-card-container {
    width: ${toRem(228)};
    border-radius: ${contextualVariable?.brandCardsBorderRadius};
  }

  .mobile-mini-card-container {
    width: ${toRem(327)};
    border-radius: ${contextualVariable?.brandCardsBorderRadius};
  }

  .mini-card-image {
    width: ${toRem(212)};
    height: ${toRem(141.4)};
    border-radius: ${contextualVariable?.brandCardsBorderRadius};
  }

  .mobile-mini-card-image {
    width: ${toRem(111)};
    border-radius: ${contextualVariable?.brandCardsBorderRadius};
  }

  .mini-card-img-container {
    width: ${toRem(212)};
    position: relative;
  }

  .brand-logo-container {
    position: absolute;
    bottom: ${toRem(16)};
    background: none;
    svg {
      max-height: ${toRem(19)} !important;
    }
  }

  .list-mini-card-container {
    width: ${toRem(343)};
    border-bottom: ${toRem(1)} solid ${baseVariables.color['neutral30']};
    min-height: ${toRem(113)};
    img {
      max-height: ${toRem(96)};
    }
  }

  .list-mini-card-image {
    width: ${toRem(96)};
    border-radius: ${contextualVariable?.brandCardsBorderRadius};
  }

  .m-link-tertiary-button {
    width: fit-content;
  }

  .icon-star-fill {
    color: ${contextualVariable?.actionLinkColor};
  }
`;
